import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor( private userService: UserService, private router: Router ){}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
      return new Promise((resolve) => {
        const loggedIn = this.userService.isLoggedIn();
        if (!loggedIn || !this.userService.hasCompleteSession()) {
          // Logged in but missing the user, salon or token: the page would
          // render without the data it needs, so start the session over.
          if (loggedIn) {
            this.userService.logout();
          }
          // Store the intended URL as a query parameter
          this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
          resolve(false);
          return;
        }

        if (this.userService.isImpersonating() && this.userService.isSessionExpired()) {
          this.userService.endImpersonation();
          resolve(false);
          return;
        }

        resolve(true);
      });

 
  }
  
}
